import { useEffect, useState } from 'react';
import { Typography } from 'antd';
import AppLayout from '../components/common/Layout';
import MeetingsTable from '../components/tables/MeetingsTable';
import { meetingApi } from '../api/adminApi';

const { Title, Text } = Typography;

const Meetings = () => {
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMeetings = async () => {
      setLoading(true);
      try {
        const response = await meetingApi.getAll();
        setMeetings(response.data.meetings);
      } catch {
        setMeetings([]);
      } finally {
        setLoading(false);
      }
    };
    fetchMeetings();
  }, []);

  return (
    <AppLayout>
      <div className="page-header">
        <Title level={3}>Итоги встреч</Title>
        <Text type="secondary">Записи One-to-One созвонов</Text>
      </div>
      <MeetingsTable meetings={meetings} loading={loading} showMember />
    </AppLayout>
  );
};

export default Meetings;
